import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Illustration, TextContainer } from './Maintenance.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { MAINTENANCE_ERROR_MESSAGE } from 'utilities/constants';
import { pageUrl } from 'utilities/pageUrl';

export const Maintenance = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <div>
        <Illustration src="/notFound.svg" alt="Maintenance" />
      </div>
      <TextContainer>
        <Heading tag="h1" styledAs="h1" noMargin>
          Maintenance In Progress
        </Heading>
        <Text tag="p" size="lg">
          {MAINTENANCE_ERROR_MESSAGE}
        </Text>
        <Button
          label={'Back to Login'}
          category="primary"
          onClick={() => navigate(pageUrl.login())}
        />
      </TextContainer>
    </Container>
  );
};
